import { useController, useGame } from "../context";
import type { ReactNode } from "react";

function Centered({ children }: { children: ReactNode }) {
  return <section className="screen screen--centered">{children}</section>;
}

export function LoadingScreen() {
  return (
    <Centered>
      <h3>Загрузка…</h3>
    </Centered>
  );
}

export function NoTelegramScreen() {
  return (
    <Centered>
      <h1>❌ Доступ запрещён</h1>
      <p>Откройте это мини-приложение только через Telegram</p>
    </Centered>
  );
}

export function FatalScreen() {
  const controller = useController();
  const message = useGame((s) => s.fatalMessage);
  return (
    <Centered>
      <h2>😕 Не получилось</h2>
      <p>{message}</p>
      <button type="button" className="btn" onClick={() => void controller.init()}>
        Повторить
      </button>
    </Centered>
  );
}

export function SubscribeScreen() {
  const controller = useController();
  const busy = useGame((s) => s.busy);
  return (
    <Centered>
      <h2>🔒 Доступ ограничен</h2>
      <p>Подпишитесь на наш канал, чтобы пользоваться приложением</p>
      <button type="button" className="btn" onClick={() => controller.openChannel()}>
        Подписаться 📢
      </button>
      <button
        type="button"
        className="btn"
        disabled={busy}
        onClick={() => void controller.recheckSubscription()}
      >
        Я подписался ✅
      </button>
    </Centered>
  );
}

export function NoMatchScreen() {
  const controller = useController();
  const inRoom = useGame((s) => s.session?.kind === "room");
  return (
    <Centered>
      <h2>😔 Совпадений не найдено</h2>
      <p className="muted">Вы посмотрели все фильмы</p>
      <div className="stack">
        <button type="button" className="btn" onClick={() => void controller.retry()}>
          🔁 Попробовать ещё раз
        </button>
        {inRoom && (
          <button type="button" className="btn" onClick={() => void controller.watchSolo()}>
            👤 Смотреть одному
          </button>
        )}
        <button type="button" className="btn" onClick={() => controller.goHome()}>
          🏠 На главную
        </button>
      </div>
    </Centered>
  );
}
